import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from '@/app/core/auth/login/presentation/LoginPage';

import { ROUTES } from './routes';

/** Public area (`/auth/*`). Registration is handled by the backend flows. */
export const AuthNavigation = () => (
  <Routes>
    <Route path="login" element={<LoginPage />} />
    <Route path="/*" element={<Navigate to={ROUTES.login} replace />} />
  </Routes>
);
